import { useDispatch, useSelector } from "react-redux";
import {
  selectClientAccountNumber,
  selectClientPropertyDetails,
  setClientAccountNumber,
  setClientID,
  setClientPropertyDetails,
} from "./components/ContactDetailsSlice";
import ClientEmailAddressesList from "./components/clientEmailAddresses/ClientEmailAddressesList";
import ClientAddressesList from "./components/clientAddresses/ClientAddressesList";
import PageWrapper from "app/modules/shared/PageWrapper";
import { useParams } from "react-router-dom";
import { getLinkedAccounts, selectClientContactDetails } from "./components/LinkedAccountsSlice";
import { useEffect } from "react";
import { useThunkDispatch } from "setup/redux/thunkDispatch";

export function ContactDetails() {
  const dispatch = useDispatch();
  const thunkDispatch = useThunkDispatch();
  const params = useParams();
  const accountNumber = useSelector(selectClientAccountNumber);
  const propertyDetails = useSelector(selectClientPropertyDetails);
  const clientContactDetails = useSelector(selectClientContactDetails);

  useEffect(() => {
    thunkDispatch(getLinkedAccounts());
  }, [thunkDispatch]);

  useEffect(() => {
    if (clientContactDetails.length > 0 && params.accountNumber) {
      const matchingContact = clientContactDetails.find((contact) => contact.accountNumber === params.accountNumber);

      if (matchingContact) {
        dispatch(setClientID(matchingContact.clientID));
        dispatch(setClientAccountNumber(matchingContact.accountNumber));
        dispatch(setClientPropertyDetails(matchingContact.property));
      }
    }
  }, [clientContactDetails, params.accountNumber, dispatch]);

  if (!accountNumber || !propertyDetails) {
    return <div>Loading...</div>;
  }

  return (
    <PageWrapper
      title={`${accountNumber} - ${propertyDetails}`}
      backTo="/account"
      data-test-id="contact-details__back-button"
    >
      <div className="mb-2">
        <ClientAddressesList />
      </div>
      <div className="mb-2">
        <ClientEmailAddressesList />
      </div>
    </PageWrapper>
  );
}
